import { useMemo } from "react"

import { usePdfBuilderStore } from "@/stores/pdfBuilder"
import {
  useReportTemplateDetailQuery,
  useReportTemplateMetasQuery,
} from "@/hooks/api/useReportQuery"
import { REPORT_TYPE } from "@/app/report/common/constants"

/**
 * PDF 빌더가 따르는 리포트 템플릿 — Report Filters 에서 고른 것, 없으면 리포트 화면(ReportFilter)과 같은 기준으로
 * 최근 사용 → 첫 번째. PdfDataContext(섹션 설정 출처)와 편집 페이지(초기 배치 시드)가 같은 훅을 쓴다 (#75).
 */
export function useBuilderReportTemplate() {
  const filterReportTemplateId = usePdfBuilderStore((s) => s.filterReportTemplateId)
  // 리포트 종류에 맞는 템플릿 목록 — 트렌드는 트렌드 템플릿에서 기본 구성을 가져온다 (2026-10-02 요청)
  const reportKind = usePdfBuilderStore((s) => s.filterReportKind)

  const { data: templateMetas, isLoading: isListLoading } = useReportTemplateMetasQuery({
    reportType: reportKind === "trend" ? REPORT_TYPE.TREND : REPORT_TYPE.DAILY,
  })
  const reportTemplateId = useMemo(() => {
    if (filterReportTemplateId) {
      return filterReportTemplateId
    }
    if (!templateMetas?.length) {
      return null
    }

    return (
      templateMetas.find((template) => template.isLastUsed)?.idfTemplate ??
      templateMetas[0].idfTemplate
    )
  }, [filterReportTemplateId, templateMetas])
  const { data: reportTemplate, isLoading: isDetailLoading } = useReportTemplateDetailQuery(
    reportTemplateId ?? undefined,
  )

  return {
    reportTemplateId,
    reportTemplate: reportTemplate ?? null,
    isLoading: isListLoading || isDetailLoading,
  }
}
